import { render } from "./IconTemplate.vue?vue&type=template&id=41e0457b&scoped=true"
import script from "./IconTemplate.vue?vue&type=script&lang=js"
export * from "./IconTemplate.vue?vue&type=script&lang=js"

import "./IconTemplate.vue?vue&type=style&index=0&id=41e0457b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e0457b"]])

export default __exports__